import React, { useState } from 'react';
import NavigationIconeDR from './NavigationIconeDR';
import logoAllonge from '../../assets/DiagoRisk/DiagoRisk-logoallongé.png';

/**
 * Frame Figma "entete_simple".
 *
 * Remplace l'ancienne MEP/entete.js. Plus de couleur de fond par rôle ou par
 * formule commerciale (Q4) : fond blanc uni pour tout le monde.
 *
 * Le bouton burger ouvre le panneau "naviagtion_sur_icone_DR" (le logo rond de la
 * maquette faisait doublon avec le logo allongé à droite).
 *
 * @param titre       titre affiché au centre de l'entête
 * @param sousTitre   (optionnel) texte sous le titre, centré, pas en gras et un
 *                    peu plus petit — ex. la région agricole dans l'OAD
 * @param retour      si fourni, affiche un bouton "Retour" à gauche ; la valeur
 *                    est la route cible. Utilisé par la prévisualisation du
 *                    rapport PDF, qui n'a pas d'autre moyen de sortie (R1).
 */
export default function EnteteSimple({ titre, sousTitre, retour }) {
  const [menuOuvert, setMenuOuvert] = useState(false);

  return (
    <div className="entete-simple">
      <div className="entete-simple-gauche">
        <button
          type="button"
          className={`entete-simple-burger${menuOuvert ? ' entete-simple-burger-ouvert' : ''}`}
          onClick={() => setMenuOuvert((ouvert) => !ouvert)}
          aria-label="Ouvrir le menu de navigation"
          aria-expanded={menuOuvert}
        >
          <span />
          <span />
          <span />
        </button>

        {retour && (
          <a className="entete-simple-retour" href={retour}>
            Retour
          </a>
        )}
      </div>

      <div className="entete-simple-titre">
        {titre}
        {sousTitre && <div className="entete-simple-sous-titre">{sousTitre}</div>}
      </div>

      <div className="entete-simple-droite">
        <img className="entete-simple-logo-allonge" src={logoAllonge} alt="DiagoRisk" />
      </div>

      {menuOuvert && <NavigationIconeDR onFermer={() => setMenuOuvert(false)} />}
    </div>
  );
}
